import { useState } from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';

import { PageForm } from './pageSlice';

interface ChildProps {
	pf: PageForm;
	onPFChange: (pf: PageForm) => void;
}

export default function PageDisplay({pf, onPFChange}: ChildProps) {
	const [title, setTitle] = useState<string>(pf.title);
	const onTitleChange = (t: string) => {
		pf.title = t;
		setTitle(t);
		onPFChange(pf);
	};
	const [kprivate, setKPrivate] = useState<boolean>(pf.kprivate);
	const onPrivateChange = (pr: boolean) => {
		pf.kprivate = pr;
		setKPrivate(pr);
		onPFChange(pf);
	};
	const [star, setStar] = useState<boolean>(pf.star);
	const onStarChange = (pr: boolean) => {
		pf.star = pr;
		setStar(pr);
		onPFChange(pf);
	};
	const [tag, setTag] = useState<string>(pf.tag);
	const onTagChange = (t: string) => {
		pf.tag = t;
		setTag(t);
		onPFChange(pf);
	};
	const [ktype, setKType] = useState<number>(pf.ktype);
	const onKTypeChange = (t: number) => {
		pf.ktype = t;
		setKType(t);
		onPFChange(pf);
	};
	const [content, setContent] = useState<string>(pf.content);
	const onContentChange = (t: string) => {
		pf.content = t;
		setContent(t);
		onPFChange(pf);
	};
	return (
		<Box sx={{overflow: 'auto', maxWidth: '1100px'}}>
			ok
			<TextField
				id="page-edit-title"
				label="Title"
				variant="standard"
				value={title}
				fullWidth
				onChange={(e) => {onTitleChange(e.target.value)}}
				required />
			<br /><br />
			<TextField
				id="page-edit-tag"
				label="Tag"
				variant="standard"
				value={tag}
				onChange={(e) => {onTagChange(e.target.value)}}
				required />
			-
			<PageTypeSelect
				initial={ktype}
				onChange={onKTypeChange}
			/>
			<br /><br />
			<TextField
				id="page-edit-content"
				label="Content"
				variant="standard"
				value={content}
				placeholder="Placeholder"
				inputProps={{style: {fontFamily:'courier new', fontSize:12}}}
				multiline
				fullWidth
				onChange={(e) => {onContentChange(e.target.value)}}
				sx={{fontFamily: 'courrier'}}
				/>
		</Box>
	);
}

interface SelectProps {
	initial: number;
	onChange: (value: number) => void;
}

function PageTypeSelect({initial, onChange}: SelectProps) {
	const [ktype, setKType] = useState(initial);
	const handleChange = (event: SelectChangeEvent) => {
		var n: number = +event.target.value;
		setKType(n);
		onChange(n);
	};
	console.log("thge.202501261125", ktype);
	return (
		<Select
			defaultValue={"" + ktype}
			value={"" + ktype}
			onChange={handleChange}
		>
			<MenuItem value={"1"}>Page</MenuItem>
			<MenuItem value={"2"}>Post</MenuItem>
			<MenuItem value={"3"}>Goal</MenuItem>
			<MenuItem value={"4"}>Requirement</MenuItem>
			<MenuItem value={"5"}>Obstacle</MenuItem>
			<MenuItem value={"6"}>Domain</MenuItem>
			<MenuItem value={"7"}>Agent</MenuItem>
			<MenuItem value={"8"}>Object</MenuItem>
			<MenuItem value={"9"}>Operation</MenuItem>
		</Select>
	);
}
